import { defineMessages } from 'react-intl';

export const servicePlanItemsMessages = defineMessages({
    servicePlanItems: {
        id: 'service-plan-items',
        defaultMessage: 'Service plan items',
    },
    items: {
        id: 'items',
        defaultMessage: 'Items',
    },
    item: {
        id: 'item',
        defaultMessage: 'Item',
    },
    metric: {
        id: 'metric',
        defaultMessage: 'Metric',
    },
    externalId: {
        id: 'external-id',
        defaultMessage: 'External ID',
    },
    isRequired: {
        id: 'is-required',
        defaultMessage: 'Is required',
    },
    createServicePlanItemSuccess: {
        id: 'create-service-plan-item-success',
        defaultMessage: 'Service plan item created',
    },
    createServicePlanItemSuccessDescription: {
        id: 'create-service-plan-item-success-description',
        defaultMessage: 'Service plan item {entry} has been successfully created.',
    },
    addServicePlanItemSubtitle: {
        id: 'add-service-plan-item-subtitle',
        defaultMessage: 'Create a new service plan item',
    },
    metricHint: {
        id: 'service-plan-item-metric-hint',
        defaultMessage: 'Leave empty for a fixed fee. Required when the pricing model is per unit.',
    },
    deleteServicePlanItem: {
        id: 'delete-service-plan-item',
        defaultMessage: 'Delete service plan item',
    },
    deleteServicePlanItemSuccess: {
        id: 'delete-service-plan-item-success',
        defaultMessage: 'Service plan item deleted',
    },
    deleteServicePlanItemSuccessDescription: {
        id: 'delete-service-plan-item-success-description',
        defaultMessage: 'The service plan item has been successfully deleted.',
    },
    confirmDeleteServicePlanItem: {
        id: 'confirm-delete-service-plan-item',
        defaultMessage: 'Are you sure you want to delete this service plan item? This action cannot be undone.',
    },
    deleteServicePlanItemSubtitle: {
        id: 'delete-service-plan-item-subtitle',
        defaultMessage: 'Permanently delete service plan item {entity}',
    },
    editServicePlanItemSubtitle: {
        id: 'edit-service-plan-item-subtitle',
        defaultMessage: 'Edit service plan item {entity}',
    },
    updateServicePlanItemSuccess: {
        id: 'update-service-plan-item-success',
        defaultMessage: 'Service plan item updated',
    },
    updateServicePlanItemSuccessDescription: {
        id: 'update-service-plan-item-success-description',
        defaultMessage: 'Service plan item {entity} has been successfully updated.',
    },
    servicePlanItemDashboard: {
        id: 'service-plan-item-dashboard',
        defaultMessage: 'Service plan item dashboard',
    },
    backToServicePlanDashboard: {
        id: 'back-to-service-plan-dashboard',
        defaultMessage: 'Back to service plan dashboard',
    },
    overlapDateRangeError: {
        id: 'custom-error:overlapping_date_range',
        defaultMessage: 'The selected date range overlaps with an existing period!',
    },
    invalidDateRangeError: {
        id: 'custom-error:invalid_date_range',
        defaultMessage: 'Start date cannot be the same as or later than the end date!',
    },
    requiredStatusAndQuantityError: {
        id: 'custom-error:service_plan_item_required_status_and_starting_quantity_modification',
        defaultMessage:
            'Required status and starting quantity cannot be modified because the service plan item have subscription items related to it!',
    },
    deactivateServicePlanItemSuccess: {
        id: 'deactivate-service-plan-item-success',
        defaultMessage: 'Service plan item deactivated',
    },
    deactivateServicePlanItemSuccessDescription: {
        id: 'deactivate-service-plan-item-success-description',
        defaultMessage: 'The service plan item was deactivated successfully.',
    },
    deactivateServicePlanItem: {
        id: 'deactivate-service-plan-item',
        defaultMessage: 'Deactivate service plan item',
    },
    deactivateServicePlanItemSubtitle: {
        id: 'deactivate-service-plan-item-subtitle',
        defaultMessage: 'Deactivate service plan item {name}',
    },
    confirmDeactivateServicePlanItem: {
        id: 'confirm-deactivate-service-plan-item',
        defaultMessage: 'Are you sure you want to deactivate this service plan item? This action cannot be undone.',
    },
    activateServicePlanItemSuccess: {
        id: 'activate-service-plan-item-success',
        defaultMessage: 'Service plan item activated',
    },
    activateServicePlanItemSuccessDescription: {
        id: 'activate-service-plan-item-success-description',
        defaultMessage: 'The service plan item was activated successfully.',
    },
    activateServicePlanItem: {
        id: 'activate-service-plan-item',
        defaultMessage: 'Activate service plan item',
    },
    activateServicePlanItemSubtitle: {
        id: 'activate-service-plan-item-subtitle',
        defaultMessage: 'Activate service plan item {name}',
    },
    confirmActivateServicePlanItem: {
        id: 'confirm-activate-service-plan-item',
        defaultMessage: 'Are you sure you want to activate this service plan item? This action cannot be undone.',
    },
    deactivateServicePlanItemError: {
        id: 'custom-error:deactivate_last_active_service_plan_item',
        defaultMessage:
            'Cannot deactivated service plan item because it is the last active item in the service plan. Deactivate the entire service plan instead.',
    },
    activeServiceItemNoBillingError: {
        id: 'custom-error:activate_service_plan_item_without_billing_or_pricing_policy',
        defaultMessage:
            'The service plan item must have an active billing and pricing policy before it can be activated!',
    },
    deleteActiveServicePlanItemError: {
        id: 'custom-error:delete_active_service_plan_item',
        defaultMessage: 'Cannot delete service plan item which is active!',
    },
    startingQuantity: {
        id: 'starting-quantity',
        defaultMessage: 'Starting quantity',
    },
    unitHint: {
        id: 'service-plan-item-unit-hint',
        defaultMessage: 'Printed on the invoice lines generated for this item.',
    },
    allowsPriceCoefficient: {
        id: 'allows-price-coefficient',
        defaultMessage: 'Allow price coefficient',
    },
    allowsPriceCoefficientHint: {
        id: 'allows-price-coefficient-hint',
        defaultMessage:
            'Lets each subscription scale this item’s price. Leave off for services sold at the plan price to everybody.',
    },
});
